import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.502 11.29H8.766c-2.77 0-5.016 2.115-5.016 4.726 0 .474.408.859.912.859h10.944c.504 0 .912-.385.912-.86 0-2.61-2.246-4.726-5.016-4.726m-6.356 4.296c.225-1.695 1.762-3.008 3.62-3.008h2.736c1.857 0 3.394 1.315 3.62 3.008zM10.134 10c2.015 0 3.648-1.54 3.648-3.437 0-1.899-1.633-3.438-3.648-3.438s-3.648 1.54-3.648 3.438S8.119 10 10.134 10m0-5.586c1.257 0 2.28.964 2.28 2.149 0 1.184-1.023 2.148-2.28 2.148s-2.28-.964-2.28-2.149c0-1.184 1.023-2.148 2.28-2.148"
    }, null, -1)
  ]))]))
}
export default { render: render }